import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";

export const getAccount = (state: ApplicationState) => {
    const { isAuthenticated, isGuest, billToId, userName, email } = getSession(state);
    const billToState = getBillToState(state, billToId);
    const { value: billTo } = billToState;
    if (isAuthenticated && !isGuest && billTo) {
        return billTo;
    }
    return "";
};

export const getUser = (state: ApplicationState) => {
    const { userProfileId, userName, firstName, lastName, email } = getSession(state);
    const userState = getAccountState(state, userProfileId || undefined);
    const { value: user } = userState;
    if (user) {
        return user;
    }
    return { userName, email, firstName, lastName };
};
